import '@humanforce/mango-ui/dist/fonts/fonts.css';
import '@humanforce/mango-ui/dist/common/themes/light.css';
import '@humanforce/mango-ui/dist/mango.js';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { App } from './App';
import './index.css';

const root = document.getElementById('root');
if (!root) throw new Error('Root element not found');

createRoot(root).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
